import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2Icon, XIcon } from "lucide-react";
import { buyers, images } from "../data/content";
export function SalesPopup() {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setIndex(i => (i + 1) % buyers.length);
      setMinutesAgo(1 + Math.floor(Math.random() * 9));
      setOpen(true);
      hideTimer = window.setTimeout(() => setOpen(false), 5000);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, 14000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed left-3 right-3 top-3 z-50 sm:left-5 sm:right-auto sm:top-auto sm:bottom-28" aria-live="polite" data-id="element-50" data-mp="1zse3oahon8mb">
      <AnimatePresence data-id="element-51" data-mp="24qz3i8t0vqa8">
        {open && !dismissed && <motion.div key={index} initial={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto mx-auto flex w-full max-w-sm items-center gap-3 rounded-2xl border border-sand bg-white p-3 pr-9 shadow-[0_16px_40px_-12px_rgba(14,21,36,0.35)] relative" data-id="element-52" data-mp="29piqmcjcr846">
            <img src={images.product} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-cream object-contain" data-id="element-53" data-mp="2xfwk87hl5f0v" />
            <div className="min-w-0" data-id="element-54" data-mp="y3ap1y9wmshm">
              <p className="text-[14px] leading-snug text-ink" data-id="element-55" data-mp="y4c0w4yqvj0e">
                <span className="font-bold" data-id="element-56" data-mp="132dliubtjqdz">{buyer.name}</span> from <span className="font-bold" data-id="element-57" data-mp="v0o1g6fuj3s8">{buyer.country}</span>
              </p>
              <p className="text-[13px] leading-snug text-muted" data-id="element-58" data-mp="v2qqoo96csvw">just purchased Lipo Revision Case Atlas™</p>
              <p className="mt-0.5 flex items-center gap-1 text-[12px] font-semibold text-cta" data-id="element-59" data-mp="q3xo3qvfemai">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden data-id="element-60" data-mp="14whc1ka08n7d" />
                Verified · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-md p-1 text-muted hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" aria-label="Dismiss notification" data-id="element-61" data-mp="1dygw6lgbg7ej">
              <XIcon className="h-4 w-4" data-id="element-62" data-mp="1iqqscj80y3p9" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}